import React from 'react';
import { Link } from 'react-router-dom';
import { FiBriefcase, FiSunrise, FiStar, FiWatch } from 'react-icons/fi';

const categories = [
  {
    id: 1,
    name: 'Clothes',
    icon: FiBriefcase,
    description: 'Designer wear & casual outfits',
    bgColor: '#FEF8EE',
  },
  {
    id: 2,
    name: 'Shoes',
    icon: FiSunrise,
    description: 'Sneakers, heels & more',
    bgColor: '#F9E8C7',
  },
  {
    id: 3,
    name: 'Boots',
    icon: FiStar,
    description: 'Winter & combat boots',
    bgColor: '#FCD06B',
  },
  {
    id: 4,
    name: 'Accessories',
    icon: FiWatch,
    description: 'Watches, bags & jewelry',
    bgColor: '#F5B800',
  },
];

const Categories = () => {
  return (
    <div className="py-16 bg-[#FFF9D4]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="section-title">
            Browse by Category
          </h2>
          <p className="section-subtitle max-w-2xl mx-auto">
            Find exactly what you need from our carefully curated categories
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {categories.map((category, index) => {
            const Icon = category.icon;
            return (
              <Link
                key={category.id}
                to={`/products?category=${category.name}`}
                className="group card p-6 transition-all duration-300 stagger-item"
                style={{ 
                  animationDelay: `${index * 0.1}s`,
                  backgroundColor: category.bgColor,
                }}
              >
                <div className="flex flex-col items-center text-center">
                  <div className="w-16 h-16 rounded-[12px] bg-[#F27D16] flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300 shadow-hover">
                    <Icon className="text-white text-2xl" />
                  </div>
                  <h3 className="text-xl font-semibold text-[#386646] mb-2 group-hover:text-[#F27D16] transition-colors">
                    {category.name}
                  </h3>
                  <p className="text-[rgba(45,45,45,0.7)] text-sm">
                    {category.description}
                  </p>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Categories;
